// extracted by mini-css-extract-plugin
export default {"subtree":"tag-select-tree_subtree__38QM8"};